/**
 * @generated SignedSource<<6754109e42fc4b3c2d2296cb900ad972>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StudentsResetDiagnosticMutation$variables = {
  diagnosticId: string;
  studentId: string;
};
export type StudentsResetDiagnosticMutation$data = {
  readonly resetStudentDiagnosticAssessment: {
    readonly studentSkillDiagnosticNode: {
      readonly id: string;
      readonly isInferred: boolean;
      readonly publicUserId: string | null | undefined;
      readonly retakeAssigned: boolean;
      readonly user: {
        readonly id: string;
        readonly publicUserId: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type StudentsResetDiagnosticMutation = {
  response: StudentsResetDiagnosticMutation$data;
  variables: StudentsResetDiagnosticMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "diagnosticId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "studentId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicUserId",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "studentId",
            "variableName": "studentId"
          },
          {
            "kind": "Variable",
            "name": "studentSkillDiagnosticId",
            "variableName": "diagnosticId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "ResetStudentDiagnosticAssessmentPayload",
    "kind": "LinkedField",
    "name": "resetStudentDiagnosticAssessment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StudentSkillDiagnosticNode",
        "kind": "LinkedField",
        "name": "studentSkillDiagnosticNode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isInferred",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "retakeAssigned",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StudentsResetDiagnosticMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StudentsResetDiagnosticMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "875eb98420521d0dff53aac97afe63e8",
    "id": null,
    "metadata": {},
    "name": "StudentsResetDiagnosticMutation",
    "operationKind": "mutation",
    "text": "mutation StudentsResetDiagnosticMutation(\n  $studentId: ID!\n  $diagnosticId: ID!\n) {\n  resetStudentDiagnosticAssessment(input: {studentId: $studentId, studentSkillDiagnosticId: $diagnosticId}) {\n    studentSkillDiagnosticNode {\n      id\n      isInferred\n      retakeAssigned\n      publicUserId\n      user {\n        id\n        publicUserId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cd5982a0eaefd26fbab2e5fc01d73891";

export default node;
